import React from "react";
import { useParams } from "react-router-dom";
import FormPage from "../../components/forms/FormPage";
import { Text } from "../../types/text";
import useTextController from "../../controllers/edit/textEditController";
import FormEntitySelectionField from "../../components/forms/fields/basic/EntitySelectionField";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import renderVersionSelection from "../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import FormMultiTextField from "../../components/forms/fields/basic/MultiTextInput";
import LinksListField from "../../components/forms/common/subForms/LinksListField";
import FormTextField from "../../components/forms/fields/basic/TextField";
import useTextLogic from "../../hooks/logic/textLogic";

interface AddEditTextPageProps {
  systemLanguageType: Text["system_language_type"];
}

const AddEditTextPage: React.FC<AddEditTextPageProps> = ({
  systemLanguageType,
}) => {
  const { _id = null } = useParams<{
    _id?: string;
  }>();

  const controller = useTextController(_id || null, systemLanguageType);
  const { basedOnEnum, sourceNameEnum, digitizationEnum } =
    useTextLogic(systemLanguageType);

  return (
    <FormPage<Text> controller={controller}>
      <FormTextField name="name" label="Name" placeholder="Name" />
      <FormEntitySelectionField
        name="version"
        label="Version"
        placeholder="Select a version"
        entityCollection={SystemEntityCollections.VERSION}
        renderEntitySelection={renderVersionSelection(systemLanguageType)}
      />

      <LinksListField
        name="sources"
        typeEnum={sourceNameEnum}
        label="Sources"
        rowLabel="Source"
        typeLabel="Source Name"
        valueLabel="Link to Text"
        typePlaceHolder="Select source"
        valuePlaceHolder="Enter Link"
      />

      <FormSelectField
        name="digitization"
        label="Digitization"
        placeholder="Select a digitization"
        useEnum={digitizationEnum}
      />
      <FormSelectField
        name="based_on_type"
        label="Based On"
        placeholder="Select a based on type"
        useEnum={basedOnEnum}
      />
      <FormMultiTextField
        name="text"
        label="Text Names"
        placeholder="Enter text names"
      />
    </FormPage>
  );
};

export default AddEditTextPage;
